import React from 'react';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-12 pb-20 lg:pt-24 lg:pb-32 overflow-hidden bg-center bg-no-repeat" style={{
    backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/v8EFins23773k6gEv5HfYv/hero_bg3.png)',
    backgroundSize: '120%'
  }} data-id="element-194">
      {/* Optional overlay for better text contrast */}
      <div className="absolute inset-0 bg-white/40" data-id="element-195"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-196">
        <div className="text-center max-w-4xl mx-auto" data-id="element-197">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-white shadow-sm border border-purple-100 mb-8" data-id="element-198">
            <span className="flex h-2 w-2 rounded-full bg-teal-500 mr-2" data-id="element-199"></span>
            <span className="text-sm font-medium text-purple-900" data-id="element-200">
              Custom Apparel Since 2014
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 tracking-tight leading-tight mb-6" data-id="element-201">
            Custom T-Shirts, Screen Printing & Embroidery in{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-teal-500" data-id="element-202">
              Southern Maryland
            </span>
          </h1>

          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto mb-10" data-id="element-203">
            Custom apparel, personalized gifts, and pre-designed products for
            schools, teams, businesses, and families nationwide — with local
            service in Leonardtown, Maryland.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-204">
            <a href="/contact" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-medium rounded-full text-white bg-purple-600 hover:bg-purple-700 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-205">
              Get a Free Quote
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-206" />
            </a>
            <a href="/products" className="inline-flex items-center justify-center px-8 py-4 border-2 border-teal-500 text-lg font-medium rounded-full text-teal-700 bg-white/80 hover:bg-white transition-all" data-id="element-207">
              Shop Pre-Designed Products
            </a>
          </div>
        </div>
      </div>
    </section>;
}